import { __awaiter } from 'tslib';
import { getApi, Predicates } from 'prismic-javascript';
import { Injectable, ɵɵdefineInjectable, ɵɵinject, Component, Pipe, ChangeDetectorRef, Input, ContentChild, ViewChild, NgModule } from '@angular/core';
import { SettingsService, CoreNg } from '@inflight/core-ng';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { RichText } from 'prismic-dom';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UINgModule } from '@inflight/ui-ng';
import { UIVideoNgModule } from '@inflight/ui-video-ng';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function PrismicConfiguration() { }
if (false) {
    /** @type {?} */
    PrismicConfiguration.prototype.apiEndpoint;
    /** @type {?|undefined} */
    PrismicConfiguration.prototype.accessToken;
    /** @type {?} */
    PrismicConfiguration.prototype.linkResolver;
}
class PrismicService {
    /**
     * @param {?} settings
     */
    constructor(settings) {
        this.settings = settings;
        try {
            this.previewToken = sessionStorage.getItem(PrismicService.PREVIEW_SESSION);
        }
        catch (e) { }
    }
    /**
     * @param {?} doc
     * @return {?}
     */
    static linkResolver(doc) {
        return '/';
    }
    /**
     * @param {?} documentType
     * @param {?} tag
     * @param {?=} lang
     * @return {?}
     */
    fetchContentByType(documentType, tag, lang) {
        return __awaiter(this, void 0, void 0, /** @this {!PrismicService} */ function* () {
            /** @type {?} */
            const apiEndpoint = (/** @type {?} */ (this.settings.Properties.get(PrismicService.END_POINT)));
            /** @type {?} */
            const refLabel = (/** @type {?} */ (this.settings.Properties.get(PrismicService.REF))) || 'Master';
            if (!apiEndpoint) {
                return;
            }
            /** @type {?} */
            const api = yield getApi(apiEndpoint);
            /** @type {?} */
            const contentRef = api.refs.find((/**
             * @param {?} ref
             * @return {?}
             */
            ref => ref.label === refLabel));
            return (yield api.query([
                Predicates.at('document.type', documentType),
                Predicates.at('document.tags', Array.isArray(tag) ? tag : [tag])
            ], {
                lang: '*',
                ref: this.previewToken ? this.previewToken : contentRef.ref
            }));
        });
    }
}
PrismicService.END_POINT = 'prismic-endpoint';
PrismicService.PREVIEW_SESSION = 'prismic-preview';
PrismicService.REF = 'prismic-ref';
PrismicService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
PrismicService.ctorParameters = () => [
    { type: SettingsService }
];
/** @nocollapse */ PrismicService.ngInjectableDef = ɵɵdefineInjectable({ factory: function PrismicService_Factory() { return new PrismicService(ɵɵinject(SettingsService)); }, token: PrismicService, providedIn: "root" });
if (false) {
    /** @type {?} */
    PrismicService.END_POINT;
    /** @type {?} */
    PrismicService.PREVIEW_SESSION;
    /** @type {?} */
    PrismicService.REF;
    /** @type {?} */
    PrismicService.prototype.previewToken;
    /**
     * @type {?}
     * @private
     */
    PrismicService.prototype.settings;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PreviewComponent {
    /**
     * @param {?} route
     * @param {?} service
     * @param {?} router
     */
    constructor(route, service, router) {
        this.route = route;
        this.service = service;
        this.router = router;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.route.queryParamMap.subscribe((/**
         * @param {?} map
         * @return {?}
         */
        map => {
            /** @type {?} */
            const token = map.get('token');
            if (token) {
                this.service.previewToken = token;
                try {
                    sessionStorage.setItem(PrismicService.PREVIEW_SESSION, token);
                }
                catch (e) { }
            }
            this.router.navigate(['/']);
        }));
    }
}
PreviewComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cms-prismic-preview',
                template: '<div></div>'
            }] }
];
/** @nocollapse */
PreviewComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: PrismicService },
    { type: Router }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    PreviewComponent.prototype.route;
    /**
     * @type {?}
     * @private
     */
    PreviewComponent.prototype.service;
    /**
     * @type {?}
     * @private
     */
    PreviewComponent.prototype.router;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrismicAsHtmlPipe {
    /**
     * @param {?} value
     * @return {?}
     */
    static asHtml(value) {
        if (!value || (Array.isArray(value) && value.length === 0)) {
            return '';
        }
        try {
            /** @type {?} */
            const html = RichText.asHtml(value);
            return html;
        }
        catch (e) {
            return '';
        }
    }
    /**
     * @param {?} value
     * @param {...?} args
     * @return {?}
     */
    transform(value, ...args) {
        return PrismicAsHtmlPipe.asHtml(value);
    }
}
PrismicAsHtmlPipe.decorators = [
    { type: Pipe, args: [{
                name: 'prismicAsHTML'
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrismicAsTargetPipe {
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        if (!value) {
            return '';
        }
        try {
            /** @type {?} */
            let text = (/** @type {?} */ (RichText.asText(value)));
            text = text.toLowerCase().replace(/\s/g, '-');
            return text;
        }
        catch (e) {
            return '';
        }
    }
}
PrismicAsTargetPipe.decorators = [
    { type: Pipe, args: [{
                name: 'prismicAsTarget'
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrismicAsTextPipe {
    /**
     * @param {?} value
     * @return {?}
     */
    static asText(value) {
        if (!value) {
            return '';
        }
        try {
            /** @type {?} */
            const text = RichText.asText(value);
            return text;
        }
        catch (e) {
            return '';
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        return PrismicAsTextPipe.asText(value);
    }
}
PrismicAsTextPipe.decorators = [
    { type: Pipe, args: [{
                name: 'prismicAsText'
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrismicBannerWithCaptionComponent {
    /**
     * @param {?} changesRef
     */
    constructor(changesRef) {
        this.changesRef = changesRef;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.content) {
            if (!changes.content.currentValue ||
                changes.content.currentValue.slice_type !== PrismicBannerWithCaptionComponent.TYPE ||
                !changes.content.currentValue.primary) {
                this.header = undefined;
                return;
            }
            /** @type {?} */
            const content = changes.content.currentValue.primary;
            /** @type {?} */
            const header = {};
            if (content.banner_title) {
                header.title = RichText.asText(content.banner_title);
            }
            if (content.banner_description) {
                header.description = RichText.asText(content.banner_description);
            }
            if (content.banner_video_url) {
                header.video = content.banner_video_url.url;
            }
            if (content.banner_image_url) {
                header.video = content.banner_image_url.url;
            }
            this.header = header;
            this.changesRef.markForCheck();
        }
    }
}
PrismicBannerWithCaptionComponent.TYPE = 'banner_with_caption';
PrismicBannerWithCaptionComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cms-prismic-banner-with-caption',
                template: "<ui-header *ngIf=\"header\" [header]=\"header\">\n    <ng-container *ngIf=\"headerTemplate\" [ngTemplateOutlet]=\"headerTemplate\" ></ng-container>\n</ui-header>\n\n\n\n"
            }] }
];
/** @nocollapse */
PrismicBannerWithCaptionComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
PrismicBannerWithCaptionComponent.propDecorators = {
    content: [{ type: Input }],
    headerTemplate: [{ type: ContentChild, args: ['headerTemplate', { static: false },] }]
};
if (false) {
    /** @type {?} */
    PrismicBannerWithCaptionComponent.TYPE;
    /** @type {?} */
    PrismicBannerWithCaptionComponent.prototype.content;
    /** @type {?} */
    PrismicBannerWithCaptionComponent.prototype.headerTemplate;
    /** @type {?} */
    PrismicBannerWithCaptionComponent.prototype.header;
    /**
     * @type {?}
     * @private
     */
    PrismicBannerWithCaptionComponent.prototype.changesRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrismicCardComponent {
    constructor() { }
}
PrismicCardComponent.TYPE = 'card';
PrismicCardComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cms-prismic-card',
                template: "<section class=\"card h-100\" *ngIf=\"card\">\n  <ng-container *ngTemplateOutlet=\"cardTemplate? cardTemplate: defaultCardTemplate;context:{card: card}\"></ng-container>\n</section>\n\n<ng-template #defaultCardTemplate let-card=\"card\">\n  <a *ngIf=\"card.card_link_url?.url\" [href]=\"card.card_link_url?.url\">\n    <ng-container *ngTemplateOutlet=\"justImageCard\"></ng-container>\n  </a>\n  <a *ngIf=\"card.route\" [routerLink]=\"card.route\" [queryParams]=\"{searchable: card.category}\">\n    <ng-container *ngTemplateOutlet=\"justImageCard;context:{'card':card}\"></ng-container>\n  </a>\n  <ng-container *ngIf=\"!card.route && !card.card_link_url?.url\">\n    <ng-container *ngTemplateOutlet=\"justImageCard;context:{'card':card}\"></ng-container>\n  </ng-container>\n</ng-template>\n\n<ng-template #justImageCard let-card=\"card\">\n\n  <img class=\"card-img-top\" *ngIf=\"card.card_image_url?.url\" [src]=\"card.card_image_url?.url\" alt=\"{{card.card_image_alt_text}}\">\n  <div class=\"card-body\">\n    <i *ngIf=\"card?.icon\" class=\"ifc-icon {{card.icon | prismicAsText}}\"></i>\n    <div [innerHTML]=\"card.card_title | prismicAsText\"> </div>\n    <div [innerHTML]=\"card.card_description | prismicAsHTML\"> </div>\n  </div>\n\n</ng-template>\n"
            }] }
];
/** @nocollapse */
PrismicCardComponent.ctorParameters = () => [];
PrismicCardComponent.propDecorators = {
    card: [{ type: Input }],
    cardTemplate: [{ type: ContentChild, args: ['cardTemplate', { static: false },] }]
};
if (false) {
    /** @type {?} */
    PrismicCardComponent.TYPE;
    /** @type {?} */
    PrismicCardComponent.prototype.card;
    /** @type {?} */
    PrismicCardComponent.prototype.cardTemplate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrismicCardsComponent {
    constructor() { }
}
PrismicCardsComponent.TYPE = 'cards';
PrismicCardsComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cms-prismic-cards',
                template: "<div class=\"jumbotron m-0 {{content?.primary?.cards_title | prismicAsTarget}}\">\n  <section class=\"container\" *ngIf=\"content\">\n    <h2 class=\"display-4\" [innerHTML]=\"content?.primary?.cards_title | prismicAsText\"></h2>\n    <p *ngIf=\"content?.primary?.cards_description\" [innerHTML]=\"content?.primary?.cards_description | prismicAsText\">\n    </p>\n    <div class=\"row pt-5\">\n      <ng-container *ngFor=\"let card of content.items\">\n        <ng-container *ngTemplateOutlet=\"cardsTemplate? cardsTemplate: defaultCardsTemplate;context:{card:card}\">\n        </ng-container>\n      </ng-container>\n    </div>\n\n  </section>\n\n  <ng-template #defaultCardsTemplate let-card=\"card\">\n    <ui-cms-prismic-card class=\"col-6 col-md-3 pb-4\" [card]=\"card\"></ui-cms-prismic-card>\n  </ng-template>\n</div>\n"
            }] }
];
/** @nocollapse */
PrismicCardsComponent.ctorParameters = () => [];
PrismicCardsComponent.propDecorators = {
    content: [{ type: Input }],
    cardsTemplate: [{ type: ContentChild, args: ['cardsTemplate', { static: false },] }]
};
if (false) {
    /** @type {?} */
    PrismicCardsComponent.TYPE;
    /** @type {?} */
    PrismicCardsComponent.prototype.content;
    /** @type {?} */
    PrismicCardsComponent.prototype.cardsTemplate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrismicCarouselComponent {
    constructor() { }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.carousel) {
            $(this.carousel).carousel({ interval: 2000 });
        }
    }
    /**
     * @return {?}
     */
    next() {
        if (this.carousel) {
            $(this.carousel).carousel('next');
        }
    }
    /**
     * @return {?}
     */
    prev() {
        if (this.carousel) {
            $(this.carousel).carousel('prev');
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.carousel) {
            $(this.carousel).carousel('dispose');
        }
    }
}
PrismicCarouselComponent.TYPE = 'carousel';
PrismicCarouselComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cms-prismic-carousel',
                template: "<div class=\"jumbotron bg-white m-0\">\n  <section *ngIf=\"content?.slice_type === 'carousel'\">\n    <div class=\"container\">\n      <h2 class=\"display-4\" [innerHTML]=\"content?.primary?.carousel_title | prismicAsText\"></h2>\n      <p *ngIf=\"content?.primary?.carousel_description\"\n        [innerHTML]=\"content?.primary?.carousel_description | prismicAsText\"></p>\n    </div>\n\n    <ui-carousel [items]=\"content?.items\">\n      <ng-template #carouselItemTemplate let-item=\"item\">\n        <div class=\"container\">\n          <div class=\"row no-gutters justify-content-center py-5 align-items-center\">\n            <div class=\"col-sm-8\">\n              <img class=\"img-fluid\" [src]=\"item.carousel_slide_image_url.url\" alt=\"{{item.carousel_slide_image_alt_text}}\">\n            </div>\n            <div class=\"col-sm-4\">\n              <div class=\"card p-4\">\n                <h3 class=\"font-weight-normal\" [innerHTML]=\"item.carousel_slide_title | prismicAsText\"></h3>\n                <p class=\"text-muted m-0\" [innerHTML]=\"item.carousel_slide_description | prismicAsHTML\"></p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </ng-template>\n    </ui-carousel>\n  </section>\n</div>\n"
            }] }
];
/** @nocollapse */
PrismicCarouselComponent.ctorParameters = () => [];
PrismicCarouselComponent.propDecorators = {
    carousel: [{ type: ViewChild, args: ['.carousel', { static: false },] }],
    carouselItemTemplate: [{ type: ContentChild, args: ['carouselItemTemplate', { static: false },] }],
    content: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    PrismicCarouselComponent.TYPE;
    /** @type {?} */
    PrismicCarouselComponent.prototype.carousel;
    /** @type {?} */
    PrismicCarouselComponent.prototype.carouselItemTemplate;
    /** @type {?} */
    PrismicCarouselComponent.prototype.content;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrismicFooterComponent {
    constructor() { }
}
PrismicFooterComponent.TYPE = 'footer';
PrismicFooterComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cms-prismic-footer',
                template: "<footer>\n  <ng-container *ngTemplateOutlet=\"footerTemplate? footerTemplate: defaultFooterBody\"></ng-container>\n  <div [innerHTML]=\"title | prismicAsText\"></div>\n  <div [innerHTML]=\"copyright | prismicAsText\"></div>\n</footer>\n\n<ng-template #defaultFooterBody>\n\n</ng-template>\n"
            }] }
];
/** @nocollapse */
PrismicFooterComponent.ctorParameters = () => [];
PrismicFooterComponent.propDecorators = {
    body: [{ type: Input }],
    title: [{ type: Input }],
    copyright: [{ type: Input }],
    footerTemplate: [{ type: ContentChild, args: ['footerTemplate', { static: false },] }]
};
if (false) {
    /** @type {?} */
    PrismicFooterComponent.TYPE;
    /** @type {?} */
    PrismicFooterComponent.prototype.body;
    /** @type {?} */
    PrismicFooterComponent.prototype.title;
    /** @type {?} */
    PrismicFooterComponent.prototype.copyright;
    /** @type {?} */
    PrismicFooterComponent.prototype.footerTemplate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrismicImageVideoContentComponent {
    constructor() { }
}
PrismicImageVideoContentComponent.TYPE = 'image-video-content';
PrismicImageVideoContentComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cms-prismic-image-video-content',
                template: "<section class=\"bg-gray-100 jumbotron\" *ngIf=\"content?.slice_type === 'image-video-content'\">\n  <div class=\"container\">\n    <h2 class=\"pb-4 display-4\" [innerHTML]=\"content?.primary?.section_title | prismicAsText\"></h2>\n    <p class=\"lead\" [innerHTML]=\"content?.primary?.section_description | prismicAsHTML\"></p>\n    <div class=\"row no-gutters justify-content-center py-5 align-items-center\" *ngFor=\"let sub of content?.items\">\n\n      <div class=\"col-sm-8\">\n        <img class=\"img-fluid\" [src]=\"sub.image_url.url\" alt=\"{{sub.image_alt_text}}\">\n      </div>\n      <div class=\"col-sm-4\">\n        <div class=\"card p-4\">\n          <h3 class=\"font-weight-normal\" [innerHTML]=\"sub.title | prismicAsText\"></h3>\n          <p class=\"text-muted m-0\" [innerHTML]=\"sub.content | prismicAsHTML\"></p>\n        </div>\n      </div>\n\n    </div>\n  </div>\n</section>\n"
            }] }
];
/** @nocollapse */
PrismicImageVideoContentComponent.ctorParameters = () => [];
PrismicImageVideoContentComponent.propDecorators = {
    content: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    PrismicImageVideoContentComponent.TYPE;
    /** @type {?} */
    PrismicImageVideoContentComponent.prototype.content;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrismicNavBarComponent {
    /**
     * @param {?} prismicService
     * @param {?} changesRef
     */
    constructor(prismicService, changesRef) {
        this.prismicService = prismicService;
        this.changesRef = changesRef;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes) {
            if (!changes.type || !changes.type.currentValue) {
                this.contentType = PrismicNavBarComponent.TYPE;
            }
            else {
                this.contentType = changes.type.currentValue;
            }
            this.updateData();
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
        if (this.customerSubscription) {
            this.customerSubscription.unsubscribe();
        }
    }
    /**
     * @return {?}
     */
    updateData() {
        return __awaiter(this, void 0, void 0, /** @this {!PrismicNavBarComponent} */ function* () {
            if (!this.tags) {
                return;
            }
            /** @type {?} */
            const response = yield this.prismicService.fetchContentByType(this.contentType, this.tags);
            if (response && response.results) {
                this.navData = response.results.find((/**
                 * @param {?} r
                 * @return {?}
                 */
                r => r.type === this.contentType));
                if (this.navData) {
                    this.navContent = this.navData.data.body.find((/**
                     * @param {?} b
                     * @return {?}
                     */
                    b => b.slice_type === 'navbar'));
                }
                else {
                    this.navContent = undefined;
                }
                this.changesRef.detectChanges();
            }
        });
    }
}
PrismicNavBarComponent.TYPE = 'global_navigation';
PrismicNavBarComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cms-prismic-nav-bar',
                template: "<ng-container *ngTemplateOutlet=\"navListTemplate ? navListTemplate : defaultNavListTemplate; context: { navContent: navContent }\"></ng-container>\n\n<ng-template #defaultNavListTemplate let-navContent=\"navContent\">\n  <ul class=\"nav navbar-nav pl-lg-2 pl-xl-5\" *ngIf=\"navContent?.items\">\n    <li class=\"nav-item\" *ngFor=\"let item of navContent?.items\">\n      <a class=\"mx-2 mx-xl-3 nav-link\" [routerLink]=\"item?.link | prismicAsText\" queryParamsHandling=\"merge\" routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\">\n        <span [innerHTML]=\"item?.title | prismicAsText\"></span>\n      </a>\n    </li>\n  </ul>\n</ng-template>\n"
            }] }
];
/** @nocollapse */
PrismicNavBarComponent.ctorParameters = () => [
    { type: PrismicService },
    { type: ChangeDetectorRef }
];
PrismicNavBarComponent.propDecorators = {
    type: [{ type: Input }],
    tags: [{ type: Input }],
    navListTemplate: [{ type: ContentChild, args: ['navListTemplate', { static: false },] }]
};
if (false) {
    /** @type {?} */
    PrismicNavBarComponent.TYPE;
    /** @type {?} */
    PrismicNavBarComponent.prototype.type;
    /** @type {?} */
    PrismicNavBarComponent.prototype.tags;
    /** @type {?} */
    PrismicNavBarComponent.prototype.navListTemplate;
    /** @type {?} */
    PrismicNavBarComponent.prototype.navData;
    /** @type {?} */
    PrismicNavBarComponent.prototype.navContent;
    /**
     * @type {?}
     * @private
     */
    PrismicNavBarComponent.prototype.contentType;
    /**
     * @type {?}
     * @private
     */
    PrismicNavBarComponent.prototype.customerSubscription;
    /**
     * @type {?}
     * @private
     */
    PrismicNavBarComponent.prototype.routeSubscription;
    /**
     * @type {?}
     * @private
     */
    PrismicNavBarComponent.prototype.prismicService;
    /**
     * @type {?}
     * @private
     */
    PrismicNavBarComponent.prototype.changesRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrismicSimpleContentComponent {
    constructor() { }
}
PrismicSimpleContentComponent.TYPE = 'simple_content';
PrismicSimpleContentComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cms-prismic-simple-content',
                template: "<div class=\"jumbotron bg-white m-0\">\n  <div class=\"container\">\n    <section *ngIf=\"content\">\n      <h2 class=\"display-4 mb-4\" [innerHTML]=\"content?.primary?.content_title | prismicAsText\"></h2>\n      <div class=\"row flex-column flex-md-row\">\n        <ng-container *ngFor=\"let item of content.items\">\n\n          <ng-container\n            *ngTemplateOutlet=\"contentTemplate? contentTemplate: defaultContentTemplate;context:{content:item}\">\n          </ng-container>\n        </ng-container>\n\n      </div>\n    </section>\n\n    <ng-template #defaultContentTemplate let-content=\"content\">\n      <div style=\"line-height: 2;\" class=\"col\" [innerHTML]=\"content?.content_description | prismicAsHTML\"></div>\n    </ng-template>\n  </div>\n</div>\n"
            }] }
];
/** @nocollapse */
PrismicSimpleContentComponent.ctorParameters = () => [];
PrismicSimpleContentComponent.propDecorators = {
    content: [{ type: Input }],
    contentTemplate: [{ type: ContentChild, args: ['contentTemplate', { static: false },] }]
};
if (false) {
    /** @type {?} */
    PrismicSimpleContentComponent.TYPE;
    /** @type {?} */
    PrismicSimpleContentComponent.prototype.content;
    /** @type {?} */
    PrismicSimpleContentComponent.prototype.contentTemplate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrismicVideoComponent {
    constructor() { }
}
PrismicVideoComponent.TYPE = 'video';
PrismicVideoComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cms-prisimc-video',
                template: "<div class=\"jumbotron bg-secondary m-0\">\n  <section class=\"py-5\" *ngIf=\"content?.slice_type === 'video'\">\n    <div class=\"container\">\n      <div class=\"row\" *ngIf=\"content?.primary?.introduction_text\">\n        <div class=\"col-sm-10 offset-sm-1\">\n          <p class=\"lead\" [innerHTML]=\"content?.primary?.introduction_text | prismicAsText\"></p>\n        </div>\n      </div>\n    </div>\n    <ng-container *ngIf=\"content?.primary?.video_url\">\n      <div class=\"container py-5\">\n        <div class=\"row\">\n          <div class=\"col-sm-10 offset-sm-1 col-lg-8 offset-lg-2\">\n            <ui-video\n              [video]=\"{src: content?.primary?.video_url?.url, poster: content?.primary?.video_poster_url?.url}\">\n            </ui-video>\n          </div>\n        </div>\n      </div>\n    </ng-container>\n  </section>\n</div>\n"
            }] }
];
/** @nocollapse */
PrismicVideoComponent.ctorParameters = () => [];
PrismicVideoComponent.propDecorators = {
    content: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    PrismicVideoComponent.TYPE;
    /** @type {?} */
    PrismicVideoComponent.prototype.content;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function WistiaVideo() { }
if (false) {
    /** @type {?} */
    WistiaVideo.prototype.title;
    /** @type {?} */
    WistiaVideo.prototype.description;
    /** @type {?} */
    WistiaVideo.prototype.video_poster;
    /** @type {?} */
    WistiaVideo.prototype.wista_id;
    /** @type {?} */
    WistiaVideo.prototype.time;
}
/**
 * @record
 */
function WistaContent() { }
if (false) {
    /** @type {?} */
    WistaContent.prototype.primary;
    /** @type {?} */
    WistaContent.prototype.items;
}
class WistiaVideoComponent {
    /**
     * @param {?} sanitize
     * @param {?} changesRef
     */
    constructor(sanitize, changesRef) {
        this.sanitize = sanitize;
        this.changesRef = changesRef;
        window._wq = window._wq || [];
        window._wq.push({ id: '_all', onHasData: (/**
             * @param {?} video
             * @return {?}
             */
            (video) => {
                if (this.activeVideo.wista_id === video._hashedId) {
                    this.activeVideo.time = video.humanDuration().replace('m', ':').replace('s', '');
                    this.changesRef.detectChanges();
                }
            }) });
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    slideChanged($event) {
        this.activeVideo = $event;
        this.appendVideo(this.activeVideo);
        if (this.carousel && this.carousel.nativeElement) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const activeEl = (/** @type {?} */ (this.carousel.nativeElement.querySelector('.carousel-item .is-active')));
                activeEl.scrollIntoView({ behavior: 'smooth' });
            }), 0);
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes.content && changes.content.currentValue) {
            this.videos = changes.content.currentValue.items;
            if (!this.activeVideo) {
                this.activeVideo = this.videos[0];
            }
            this.appendVideo(this.activeVideo);
        }
    }
    /**
     * @param {?} vid
     * @return {?}
     */
    updateVideo(vid) {
        this.activeVideo = vid;
        this.appendVideo(this.activeVideo);
    }
    /**
     * @param {?} video
     * @return {?}
     */
    appendVideo(video) {
        if (!video) {
            return '';
        }
        this.videoHtml = this.sanitize.bypassSecurityTrustHtml(`<div class="wistia_embed wistia_async_${video.wista_id}"></div>`);
        this.changesRef.detectChanges();
    }
}
WistiaVideoComponent.decorators = [
    { type: Component, args: [{
                selector: 'ui-cms-prismic-wistia-video',
                template: "<ng-container *ngIf=\"videos\">\n  <div class=\"jumbotron bg-white m-0\">\n    <div class=\"container\">\n      <h2 class=\"display-4 mb-5\">{{content?.primary?.title}}</h2>\n      <div class=\"row align-items-start\">\n        <div class=\"col-lg-8\">\n          <div class=\"card border-0\">\n            <div [innerHTML]=\"videoHtml\"></div>\n            <div class=\"card-body\">\n              <div class=\"h6 font-weight-bold pb-1 d-flex flex-row align-items-center\">\n                <span>{{activeVideo.title}}</span><span class=\"pl-2 text-muted small\">{{activeVideo.time}}</span></div>\n              <p class=\"small\" [innerHTML]=\"activeVideo.description | prismicAsHTML\"></p>\n            </div>\n          </div>\n        </div>\n        <div class=\"col-lg-4\" #carousel>\n          <ui-carousel [carouselOptions]=\"{'pause': true}\" [items]=\"content?.items\" (slideChange)=\"slideChanged($event)\">\n            <ng-template #carouselItemTemplate let-item=\"item\" let-goToSlide=\"goToSlide\" let-index=\"index\">\n              <div class=\"container\" [class.is-active]=\"activeVideo.wista_id === item.wista_id\">\n                <div class=\"row no-gutters justify-content-center align-items-center\">\n                  <div class=\"col-12\">\n                    <a href=\"javascript:void(0)\" role=\"button\" (click)=\"goToSlide(index)\">\n                      <img class=\"img-fluid\" [src]=\"item.video_poster?.url\" aria-hidden=\"true\">\n                      <span class=\"sr-only\">{{ 'prismic-wistia-video.goToVideo' | translate:{'title':item.title} }}</span>\n                    </a>\n                    <div class=\"h6 font-weight-bold py-2\">{{ item.title }}</div>\n                  </div>\n                </div>\n              </div>\n            </ng-template>\n          </ui-carousel>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-container>\n"
            }] }
];
/** @nocollapse */
WistiaVideoComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: ChangeDetectorRef }
];
WistiaVideoComponent.propDecorators = {
    carousel: [{ type: ViewChild, args: ['carousel', { static: false },] }],
    content: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    WistiaVideoComponent.prototype.carousel;
    /** @type {?} */
    WistiaVideoComponent.prototype.content;
    /** @type {?} */
    WistiaVideoComponent.prototype.videoHtml;
    /** @type {?} */
    WistiaVideoComponent.prototype.activeVideo;
    /** @type {?} */
    WistiaVideoComponent.prototype.videos;
    /**
     * @type {?}
     * @private
     */
    WistiaVideoComponent.prototype.sanitize;
    /**
     * @type {?}
     * @private
     */
    WistiaVideoComponent.prototype.changesRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UICMSNgModule {
    /**
     * @return {?}
     */
    static forRoot() {
        return {
            ngModule: UICMSNgModule,
            providers: [
                PrismicService
            ]
        };
    }
}
UICMSNgModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    PreviewComponent,
                    PrismicAsTextPipe,
                    PrismicAsHtmlPipe,
                    PrismicAsTargetPipe,
                    PrismicImageVideoContentComponent,
                    PrismicVideoComponent,
                    PrismicBannerWithCaptionComponent,
                    PrismicCarouselComponent,
                    PrismicCardsComponent,
                    PrismicCardComponent,
                    PrismicFooterComponent,
                    PrismicNavBarComponent,
                    PrismicSimpleContentComponent,
                    WistiaVideoComponent
                ],
                imports: [
                    CommonModule,
                    RouterModule,
                    TranslateModule,
                    CoreNg,
                    UINgModule,
                    UIVideoNgModule
                ],
                exports: [
                    PreviewComponent,
                    PrismicAsTextPipe,
                    PrismicAsHtmlPipe,
                    PrismicAsTargetPipe,
                    PrismicImageVideoContentComponent,
                    PrismicVideoComponent,
                    PrismicBannerWithCaptionComponent,
                    PrismicCarouselComponent,
                    PrismicCardsComponent,
                    PrismicCardComponent,
                    PrismicFooterComponent,
                    PrismicNavBarComponent,
                    PrismicSimpleContentComponent,
                    WistiaVideoComponent
                ]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { PreviewComponent, PrismicAsHtmlPipe, PrismicAsTargetPipe, PrismicAsTextPipe, PrismicBannerWithCaptionComponent, PrismicCardComponent, PrismicCardsComponent, PrismicCarouselComponent, PrismicFooterComponent, PrismicImageVideoContentComponent, PrismicNavBarComponent, PrismicService, PrismicSimpleContentComponent, PrismicVideoComponent, UICMSNgModule, WistiaVideoComponent };
//# sourceMappingURL=inflight-ui-cms-ng.js.map
